import { pageURLs } from "@/constants";

// Where the MLS-match digest bell row (subjectType 30) sends the agent: the
// MLS tab of My Properties, which is where the matched listings live. Tenants
// without the MLS tab fall back to the default My Properties tab. Previously
// this went to /agent-dashboard, a legacy clients overview that shows none of
// the matches the notification is about.
export const MLS_MATCH_DIGEST_TAB = "mls-active";

export function getMlsMatchDigestPath() {
  return `${pageURLs.agentInventoryListing}?tab=${MLS_MATCH_DIGEST_TAB}`;
}
